var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bottom"},[_c('div',{staticClass:"bw"},[_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.bottomValue)}})]),_c('div',{staticClass:"b2"},[_vm._v(" 版权所有©中财首佳(北京)教育科技有限公司 京ICP备2026008095号 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }